import api from "./api";
import { ISale } from "../classes/interfaces";

export async function getSaleDetail(saleId: string | undefined): Promise<ISale> {
  const res = await api().get(`/sale/${saleId}`);
  if (res.data === undefined || res.data.code === undefined || res.data.code !== 200) {
    throw new Error("Falha ao buscar pedido");
  }
  return res.data.data;
}

/**
 * Cancels a sale. Does NOT throw on a non-200 response code -- the caller's existing
 * logic branches on the response body itself (mirrors saleService.postSale's
 * rationale: the real network/axios rejection is handled separately by the caller's
 * .catch() showing a toast, while a non-200 *response* is a distinct branch the
 * caller's own logic must inspect). A real network/axios rejection still propagates
 * normally for the caller's .catch() to show its own toast.
 */
export async function cancelSale(saleId: string | undefined, reason: string): Promise<any> {
  const res = await api().put(`/sale/${saleId}/cancel`, { reasonCancellation: reason });
  return res.data;
}
